import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-question-content',
  template: `
    <div class="question-content" [ngClass]="{'has-code': hasCode}">
      <ng-container *ngIf="!hasCode; else codeContent">
        <div [innerHTML]="sanitizedContent"></div>
      </ng-container>
      <ng-template #codeContent>
        <div class="content-with-code">
          <ng-container *ngFor="let part of contentParts">
            <pre *ngIf="part.isCode" class="code-block"><code>{{part.text}}</code></pre>
            <div *ngIf="!part.isCode" [innerHTML]="part.sanitizedHtml"></div>
          </ng-container>
        </div>
      </ng-template>
    </div>
  `,
  styles: [`
    .question-content {
      line-height: 1.6;
      white-space: pre-wrap;
      word-break: break-word;
    }
    .content-with-code {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }
    .code-block {
      background: #f5f7f9;
      border: 1px solid #e1e4e8;
      border-radius: 6px;
      padding: 1rem;
      margin: 0;
      font-family: 'Consolas', 'Monaco', monospace;
      font-size: 0.9em;
      overflow-x: auto;
    }
  `]
})
export class QuestionContentComponent implements OnInit {
  @Input() content: string = '';
  sanitizedContent: SafeHtml;
  hasCode: boolean = false;
  contentParts: { text: string; isCode: boolean; sanitizedHtml?: SafeHtml }[] = [];

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit() {
    this.hasCode = this.content.includes('```') || this.content.includes('`');
    
    if (!this.hasCode) {
      this.sanitizedContent = this.sanitizer.bypassSecurityTrustHtml(this.content);
      return;
    }

    // Split content into code and non-code parts
    const parts = this.content.split(/(```[^`]*```|`[^`]*`)/g);
    this.contentParts = parts.map(part => {
      if (part.startsWith('```') && part.endsWith('```')) {
        return {
          text: part.slice(3, -3).trim(),
          isCode: true
        };
      } else if (part.startsWith('`') && part.endsWith('`')) {
        return {
          text: part.slice(1, -1).trim(),
          isCode: true
        };
      } else {
        return {
          text: part,
          isCode: false,
          sanitizedHtml: this.sanitizer.bypassSecurityTrustHtml(part)
        };
      }
    });
  }
}